import paginationHelper from '@/Helpers/pagination.helper';
import NotificationTransformer from '@/Helpers/800/notification/notification.transformer';
import SharedHelper from '@/Helpers/Shared';
export default {
  data() {
    return {
      allNotifications: [],
      notification: {},
    };
  },
  mixins: [paginationHelper, NotificationTransformer, SharedHelper],
  methods: {
    getAllNotifications: function (params) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllNotificationsDispatch', params)
        .then(() => {
          if (this.$store.state.Notifications800Module.successFlag) {
            const data = this.$store.state.Notifications800Module.allNotifications;

            this.allNotifications = this.transformNotificationsList(data);
          } else {
            if (this.$store.state.Notifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllNotifications(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.Notifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllNotifications(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getAllActiveNotifications: function (params) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllActiveNotificationsDispatch', params)
        .then(() => {
          if (this.$store.state.Notifications800Module.successFlag) {
            const data = this.$store.state.Notifications800Module.allNotifications;

            this.allNotifications = this.transformNotificationsList(data);
          } else {
            if (this.$store.state.Notifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllActiveNotifications(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.Notifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllActiveNotifications(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getNotification: function (noticeId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = { noticeId };
      this.$store
        .dispatch('getNotificationByIDDispatch', params)
        .then(() => {
          if (this.$store.state.Notifications800Module.successFlag) {
            const data = this.$store.state.Notifications800Module.notification;
            this.notification = this.transformNotification(data);
          } else {
            if (this.$store.state.Notifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getNotification(noticeId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.Notifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getNotification(noticeId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    activeNotification: function (noticeId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = { noticeId };
      this.$store
        .dispatch('activeNotificationDispatch', params)
        .then(() => {
          if (this.$store.state.Notifications800Module.successFlag) {
            this.showSuccessAlert('اعلان با موفقیت فعال شد', 5000);
            const userId = this.$store.state.userModule.userId;
            this.getAllActiveNotifications({
              userId,
            });
          } else {
            if (this.$store.state.Notifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.activeNotification(noticeId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.Notifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.activeNotification(noticeId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    deactiveNotification: function (noticeId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      const params = { noticeId };
      this.$store
        .dispatch('deactiveNotificationDispatch', params)
        .then(() => {
          if (this.$store.state.Notifications800Module.successFlag) {
            this.showSuccessAlert('اعلان با موفقیت غیرفعال شد', 5000);
            const userId = this.$store.state.userModule.userId;
            this.getAllActiveNotifications({
              userId,
              PageNumber: this.pagination?.Page,
              PageSize: this.pagination?.PageSize,
            });
          } else {
            if (this.$store.state.Notifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deactiveNotification(noticeId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.Notifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deactiveNotification(noticeId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    onError: function () {
      const message = this.$store.state.Notifications800Module.error;
      this.showErrorAlert(message, 8000);
    },
  },
};
